"use client"

import React from "react"
import { NotificationItemTemplate } from "./NotificationItemTemplate"
import { FragmentType, graphql, useFragment } from "@/gql"
import { NotificationActor } from "./NotificationActor"
import { Text } from "@/elements"

const CreativeWorkProjectLikeFragment = graphql(`
  fragment SentConnectionRequestAccepted on StreamNotificationFeedAggregatedActivity {
    id
    isRead
    isSeen
    activities {
      id
      time
      actor {
        id
        name
        ...NotificationActor
      }
    }
  }
`)

interface Props {
  onActorClick: (e: React.MouseEvent<any, MouseEvent>) => void
  item: FragmentType<typeof CreativeWorkProjectLikeFragment>
}

export const SentConnectionRequestAccepted: React.FC<Props> = props => {
  const item = useFragment(CreativeWorkProjectLikeFragment, props.item)
  const { onActorClick } = props

  const activities = item.activities?.[0]

  const actor = activities?.actor
  const actorName = actor?.name

  return (
    <NotificationItemTemplate
      isSeen={item?.isSeen}
      LeftComponent={actor && <NotificationActor actor={actor} onActorClick={onActorClick} />}
      TextContent={
        <Text element="span">
          <Text element="span" className="!font-medium" onClick={onActorClick}>
            {actorName ?? "Member"}
          </Text>{" "}
          accepted your connection request.
        </Text>
      }
      time={activities?.time}
    />
  )
}
